import React from 'react';
import { Box, Typography } from '@mui/material';
import { borderRadius, palette, spaces } from '../../../../assets/styles/themes/tokens';
import { stripMarkdown } from '../../../../utils/markdown';

interface ArtifactCardContentProps {
  content: string;
}

const contentBoxSx = {
  margin: `0 ${spaces.md}`,
  padding: spaces.sm,
  flex: 1,
  overflow: 'hidden',
  border: `1px solid ${palette.elevation.outlined}`,
  borderRadius: `${borderRadius.sm} ${borderRadius.sm} 0 0`,
};

const lineTypographySx = {
  color: palette.text.primary,
  display: 'block',
};

const ArtifactCardContent: React.FC<ArtifactCardContentProps> = ({ content }) => {
  const lines = stripMarkdown(content).split('\n').filter(Boolean);

  return (
    <Box data-testid='artifact-card-content' sx={contentBoxSx}>
      {lines.map((line, lineIndex) => (
        <Typography key={lineIndex} variant='caption2' sx={lineTypographySx}>
          {line}
        </Typography>
      ))}
    </Box>
  );
};

export default ArtifactCardContent;
